import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort_score_active",
  "use": "sort_score_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"sort_score_active\"><path d=\"M9 2a7 7 0 0 1 5.29 11.584l3.564 3.562a.5.5 0 1 1-.708.708l-3.562-3.563A7 7 0 1 1 9 2Zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 9 3Zm0 1a5 5 0 1 1 0 10A5 5 0 0 1 9 4Zm2 4h-1v2H8l2.5 2 2.5-2h-2V8ZM7.5 6 5 8h2v2h1V8h2L7.5 6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol